import { findRule } from '../Utils';

const en = /^[0-9]+$/;

const validate = (vObj) => {
  const { value } = vObj;
  const rule = findRule(vObj.errorBag, 'numeric');
  rule.feedback = `${vObj.fieldlabel} should be numeric`;
  const testValue = (val) => {
    const strValue = String(val);

    return en.test(strValue);
  };

  if (Array.isArray(value)) {
    return value.every(testValue);
  }

  return testValue(value);
};

export { validate };

export default {
  validate,
};
